import {useEffect,useState} from 'react';
import { useNavigate } from "react-router-dom";

//services
import SettingsService from '../service/Settings'
import TestService from '../service/Test'


const formatJson=function(json){
    return JSON.stringify(json); 
}
  

const SetUp = () => {
	
	const navigate = useNavigate();

		
	useEffect(() => {
		//check if server is setup
		/*SettingsService.getRootSettings().then(function(result){
			console.log('result',result.data.length);
			
		}).catch(function(error){
				console.log(error);
		});*/
		
		TestService.getAll().then(function(result){
			console.log('result',result.data.length);
			
		}).catch(function(error){
				console.log(error);
		});
		
		console.log(TestService.test());
		console.log(TestService.newtest());


	}, []);

	
	
  return(
  <>
  SetUp
  </>
)};

export default SetUp;
